export default {
  title: {
    en: 'New Products, Same Subscription',
  },
}
